import { DBH_STATIC_CATEGORY_CITY_PAGE_FORCE_DYNAMIC_QUERY_PARAM } from '@dbh/webpages-events-and-constants-redux';

/*
 *
 * Package: `@dbh/cloudflare-worker-constants`.
 *
 */
const CLOUDFLARE_GEO_HTTP_HEADER_NAMES = {
  GEO_COLO: 'dbh-cf-geo-colo',
  GEO_CITY: 'dbh-cf-geo-city',
  GEO_CONTINENT: 'dbh-cf-geo-continent',
  GEO_LAT_LNG: 'dbh-cf-geo-lat-lng',
  GEO_POSTAL_CODE: 'dbh-cf-geo-postal-code',
  GEO_METRO_CODE: 'dbh-cf-geo-metro-code',
  GEO_REGION: 'dbh-cf-geo-region',
  GEO_REGION_CODE: 'dbh-cf-geo-region-code',
  GEO_TIMEZONE: 'dbh-cf-geo-timezone',
  GEO_COUNTRY: 'dbh-cf-geo-country',
  GEO_IS_EU_COUNTRY: 'dbh-cf-is-eu-country'
};

// Make sure the node server side rendering app isn’t able (possible programming
// bug) to override the cache headers controlled by the front end cache worker.
const CLOUDFLARE_CACHE_HTTP_HEADER_NAMES = {
  PROXY_ACTION: 'dbh-cf-proxy-action',
  IS_CACHED_RESULT: 'dbh-cf-is-cached-result',
  CACHED_URL: 'dbh-cf-cached-url',
  REQUEST_URL: 'dbh-cf-request-url',
  PROXIED_ORIGIN: 'dbh-cf-proxied-origin',
  CACHE_KEY: 'dbh-cf-cache-key',
  PROXY_CODE_CHECKSUM: 'dbh-cf-proxy-code-checksum',
  PROXY_RELEASE_VERSION_CODE: 'dbh-cf-proxy-release-version-code',
  CACHE_METADATA: 'dbh-cf-cache-metadata',
  UPSTREAM_TIME: 'dbh-cf-upstream-time',
  NETWORK_TIME: 'dbh-cf-to-be-network-time',
  COMPUTE_TIME: 'dbh-cf-to-be-compute-time',
  TOTAL_TIME: 'dbh-cf-to-be-total-time',
  WAS_REQUEST_AUTHENTICATED: 'dbh-cf-was-request-authenticated',
  ...CLOUDFLARE_GEO_HTTP_HEADER_NAMES
};
const QUERY_PARAMETERS_COUNTED_IN_THE_CACHE_KEY = ['dbhq', 'code', 'email',
// `ResetPasswordPage`.
'token', 'internalGuidBooking',
// `ConfirmReservationPage`.
'guidBooking',
// Should be in `dbhq` but just in case.
'guidShoppingCart',
// @see {@link https://test.daybreakhotels.com/IT/it-IT/milano-day-use-hotels}
// Go to the link on a mobile device, or with `Chrome` (using "Network Conditions"
// to set a mobile user agent), then click on the "Map" or "Filters" buttons.
DBH_STATIC_CATEGORY_CITY_PAGE_FORCE_DYNAMIC_QUERY_PARAM];

export { CLOUDFLARE_CACHE_HTTP_HEADER_NAMES, CLOUDFLARE_GEO_HTTP_HEADER_NAMES, QUERY_PARAMETERS_COUNTED_IN_THE_CACHE_KEY };
